import React from 'react'
import { Chip } from '@mui/material'

/** How many ticket types carry an admin-set value. Stored nulls mean the field stays earned. */
const countOverrides = (overrides) =>
  Object.values(overrides ?? {}).filter((value) => value !== null && value !== undefined).length

/** Marks a company whose tickets are not purely earned. Renders nothing when none are set. */
export const TicketOverrideBadge = ({ overrides }) => {
  const count = countOverrides(overrides)

  if (count === 0) return null

  return <Chip size='small' variant='outlined' color='warning' label={count} />
}
